import styled from 'styled-components'

export const SubmitWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`
